/**
 * @generated SignedSource<<8269d9b06de18c0c6eeb4fc71bf3f6b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ElementStateKind = "Input" | "InputAndIsCorrect" | "ShowAnswer" | "Untouched" | "UntouchedAndPreviouslyIncorrect";
export type SubmitMatrixElementV2Input = {
  checkedIndices: ReadonlyArray<SubmitMatrixIndexCellInput>;
  clientMutationId?: string | null;
  contentSubmissionId: string;
  matrixElementId: string;
};
export type SubmitMatrixIndexCellInput = {
  index: number;
  xIdx: number;
  yIdx: number;
};
export type MatrixElement_SubmitMatrixElementMutation$variables = {
  input: SubmitMatrixElementV2Input;
};
export type MatrixElement_SubmitMatrixElementMutation$data = {
  readonly LearnV2: {
    readonly submitMatrixElement: {
      readonly clientMutationId: string | null;
      readonly contentSubmission: {
        readonly definition: {
          readonly currentElementState?: {
            readonly isCorrect?: boolean;
            readonly kind: ElementStateKind;
          } | null;
        };
        readonly " $fragmentSpreads": FragmentRefs<"ContentSubmissionScreen_ContentSubmissionFragment">;
      };
    } | null;
  };
};
export type MatrixElement_SubmitMatrixElementMutation = {
  response: MatrixElement_SubmitMatrixElementMutation$data;
  variables: MatrixElement_SubmitMatrixElementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCorrect",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = [
  (v6/*: any*/),
  (v3/*: any*/)
],
v10 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "extension",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isUnlockNecessaryToStart",
            "storageKey": null
          }
        ],
        "type": "LearnContentExtensionImpl",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v14 = [
  (v13/*: any*/),
  (v5/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answeringTypeText",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v18 = [
  (v17/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "xIdx",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "yIdx",
  "storageKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkedAnswerIndices",
      "storageKey": null
    }
  ],
  "type": "MultipleChoiceInputElementState",
  "abstractKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkedMistakeIndices",
      "storageKey": null
    }
  ],
  "type": "MarkMistakesInputElementState",
  "abstractKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v24 = [
  (v19/*: any*/),
  (v20/*: any*/),
  (v23/*: any*/)
],
v25 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkedAnswers",
      "storageKey": null
    }
  ],
  "type": "ClozeTextInputElementState",
  "abstractKey": null
},
v26 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "rewardResults",
    "plural": true,
    "selections": [
      (v6/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GamificationPointsReceivedByContent",
            "kind": "LinkedField",
            "name": "points",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "num",
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "GamificationPoints_PointsReceivedRewardResult",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "elementKind",
  "storageKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v13/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "UploadAsyncLearnElement",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MatrixElement_SubmitMatrixElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LearnV2Mutations",
        "kind": "LinkedField",
        "name": "LearnV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SubmitMatrixElementV2Payload",
            "kind": "LinkedField",
            "name": "submitMatrixElement",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentSubmission",
                "kind": "LinkedField",
                "name": "contentSubmission",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ContentSubmissionScreen_ContentSubmissionFragment"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "definition",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "currentElementState",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/)
                                ],
                                "type": "InputAndIsCorrectElementState",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ActiveELearningContentSubmissionDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MatrixElement_SubmitMatrixElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LearnV2Mutations",
        "kind": "LinkedField",
        "name": "LearnV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SubmitMatrixElementV2Payload",
            "kind": "LinkedField",
            "name": "submitMatrixElement",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentSubmission",
                "kind": "LinkedField",
                "name": "contentSubmission",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LearnOpportunityV2",
                    "kind": "LinkedField",
                    "name": "learnOpportunity",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "nextContentNodeId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "structureDefinition",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "extension",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ElementsSummary",
                                        "kind": "LinkedField",
                                        "name": "elementsSummary",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "numFileElements",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "sumTextLengthInSec",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "sumVideoLengthInSec",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "sumPodcastWithTimestampLengthInSec",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "numExerciseElements",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "LearnContentExtensionImpl",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LearnOpportunityELearningContentTypeDefinition",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "contentNodeAdvancementResult",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LearnOpportunityContentTypeDefinition",
                            "abstractKey": "__isLearnOpportunityContentTypeDefinition"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "indexPath",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnOpportunityV2",
                        "kind": "LinkedField",
                        "name": "root",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "viewerTreeState",
                                    "plural": false,
                                    "selections": (v9/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "extension",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CartClickout",
                                            "kind": "LinkedField",
                                            "name": "cartClickout",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "relativeLink",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "unlockInfo",
                                            "plural": false,
                                            "selections": (v9/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "ihkState",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "extension",
                                            "plural": false,
                                            "selections": [
                                              (v6/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "licenseAvailability",
                                                    "plural": false,
                                                    "selections": [
                                                      (v6/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "numAvailable",
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "type": "LicenseAvailabilityFreeLicensesAvailable",
                                                        "abstractKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "PublishedConstellationRootExtensionExtension",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "PublishedRootExtensionImpl",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "LearnOpportunityRootStructureDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnOpportunityV2",
                        "kind": "LinkedField",
                        "name": "nextContentNode",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "typeDefinition",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v10/*: any*/),
                                "type": "LearnOpportunityELearningContentTypeDefinition",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v10/*: any*/),
                                "type": "LearnAsyncContentTypeDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "definition",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "currentElementState",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "element",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "elementType",
                                    "storageKey": null
                                  },
                                  (v7/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "duration",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "File",
                                        "kind": "LinkedField",
                                        "name": "podcastFile",
                                        "plural": false,
                                        "selections": (v14/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TimestampWithImage",
                                        "kind": "LinkedField",
                                        "name": "timestampsWithImage",
                                        "plural": true,
                                        "selections": [
                                          (v11/*: any*/),
                                          (v12/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "File",
                                            "kind": "LinkedField",
                                            "name": "imageFile",
                                            "plural": false,
                                            "selections": (v14/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PodcastWithTimestampLearnElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v15/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "readMore",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "readMoreButtonText",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "EnhancedTextLearnElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StreamFile",
                                        "kind": "LinkedField",
                                        "name": "streamFile",
                                        "plural": false,
                                        "selections": (v14/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SubtitlesForLanguage",
                                        "kind": "LinkedField",
                                        "name": "subtitles",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "language",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "VideoSubtitle",
                                            "kind": "LinkedField",
                                            "name": "subtitles",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "startTimeInSec",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "endTimeInSec",
                                                "storageKey": null
                                              },
                                              (v15/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "File",
                                        "kind": "LinkedField",
                                        "name": "thumbnailFile",
                                        "plural": false,
                                        "selections": (v14/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "VideoLearnElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "File",
                                        "kind": "LinkedField",
                                        "name": "file",
                                        "plural": false,
                                        "selections": (v14/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "FileLearnElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "question",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "answeringType",
                                        "storageKey": null
                                      },
                                      (v16/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AnswerOptionWithoutCorrect",
                                        "kind": "LinkedField",
                                        "name": "answerOptions",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "answer",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "File",
                                            "kind": "LinkedField",
                                            "name": "image",
                                            "plural": false,
                                            "selections": (v14/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "MultipleChoiceLearnElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v16/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrderItem",
                                        "kind": "LinkedField",
                                        "name": "orderItems",
                                        "plural": true,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v15/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "OrderLearnElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MarkMistakes_Snippet",
                                        "kind": "LinkedField",
                                        "name": "snippets",
                                        "plural": true,
                                        "selections": (v18/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "MarkMistakesLearnElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "cells",
                                        "plural": true,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v19/*: any*/),
                                          (v20/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v17/*: any*/),
                                              (v3/*: any*/)
                                            ],
                                            "type": "DisplayMatrixLearnElementCell",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "MatrixLearnElementAnswer",
                                                "kind": "LinkedField",
                                                "name": "answers",
                                                "plural": true,
                                                "selections": (v18/*: any*/),
                                                "storageKey": null
                                              },
                                              (v3/*: any*/)
                                            ],
                                            "type": "AnswerMatrixLearnElementCell",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "MatrixLearnElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "parts",
                                        "plural": true,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v3/*: any*/),
                                          (v5/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v15/*: any*/)
                                            ],
                                            "type": "TextPart",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ClozeAnswer",
                                        "kind": "LinkedField",
                                        "name": "shuffledAnswers",
                                        "plural": true,
                                        "selections": [
                                          (v15/*: any*/),
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ClozeTextLearnElement",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "inputElementState",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v21/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "selectedOrder",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "OrderInputElementState",
                                        "abstractKey": null
                                      },
                                      (v22/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "MatrixLearnElementIndexCell",
                                            "kind": "LinkedField",
                                            "name": "checkedIndices",
                                            "plural": true,
                                            "selections": (v24/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "MatrixInputElementState",
                                        "abstractKey": null
                                      },
                                      (v25/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "InputAndIsCorrectElementState",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "correctAnswerIndices",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastCheckedAnswerIndices",
                                    "storageKey": null
                                  }
                                ],
                                "type": "MultipleChoiceShowAnswerElementState",
                                "abstractKey": null
                              },
                              (v21/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "correctOrder",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastSelectedOrder",
                                    "storageKey": null
                                  }
                                ],
                                "type": "OrderShowAnswerElementState",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "correctMistakeIndices",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastCheckedMistakeIndices",
                                    "storageKey": null
                                  }
                                ],
                                "type": "MarkMistakesShowAnswerElementState",
                                "abstractKey": null
                              },
                              (v22/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MatrixLearnElementIndexCell",
                                    "kind": "LinkedField",
                                    "name": "lastCheckedIndices",
                                    "plural": true,
                                    "selections": (v24/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MatrixLearnElementIndexCell",
                                    "kind": "LinkedField",
                                    "name": "correctIndices",
                                    "plural": true,
                                    "selections": (v24/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "MatrixShowAnswerElementState",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MatrixLearnElementIndexCell",
                                    "kind": "LinkedField",
                                    "name": "checkedIndices",
                                    "plural": true,
                                    "selections": [
                                      (v23/*: any*/),
                                      (v19/*: any*/),
                                      (v20/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "MatrixInputElementState",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "correctAnswers",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastCheckedAnswers",
                                    "storageKey": null
                                  }
                                ],
                                "type": "ClozeTextShowAnswerElementState",
                                "abstractKey": null
                              },
                              (v25/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canGoToPrevious",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canGoToNext",
                            "storageKey": null
                          }
                        ],
                        "type": "ActiveELearningContentSubmissionDefinition",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "percentage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ELearningContentSubmissionDefinition",
                        "abstractKey": "__isELearningContentSubmissionDefinition"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v26/*: any*/),
                        "type": "PassedELearningContentSubmissionDefinition",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v26/*: any*/),
                        "type": "FailedELearningContentSubmissionDefinition",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "element",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v5/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "PassedAsyncContentSubmissionDefinition",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "element",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v5/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "taskDescription",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ActiveAsyncContentSubmissionDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dd8df6f0c3a6cca203a13d4541a1835d",
    "id": null,
    "metadata": {},
    "name": "MatrixElement_SubmitMatrixElementMutation",
    "operationKind": "mutation",
    "text": "mutation MatrixElement_SubmitMatrixElementMutation(\n  $input: SubmitMatrixElementV2Input!\n) {\n  LearnV2 {\n    submitMatrixElement(input: $input) {\n      clientMutationId\n      contentSubmission {\n        ...ContentSubmissionScreen_ContentSubmissionFragment\n        definition {\n          __typename\n          ... on ActiveELearningContentSubmissionDefinition {\n            currentElementState {\n              __typename\n              kind\n              ... on InputAndIsCorrectElementState {\n                isCorrect\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AsyncContentSubmissionScreen_ContentSubmissionFragment on ContentSubmission {\n  id\n  learnOpportunity {\n    structureDefinition {\n      __typename\n      title\n    }\n    description\n    indexPath\n    id\n  }\n  definition {\n    __typename\n    ... on PassedAsyncContentSubmissionDefinition {\n      element {\n        __typename\n        id\n        elementKind\n      }\n    }\n    ... on ActiveAsyncContentSubmissionDefinition {\n      element {\n        __typename\n        id\n        elementKind\n      }\n    }\n  }\n  ...UploadElement_ContentSubmissionFragment\n  ...contentSubmissionNavigation_ContentSubmissionFragment\n  ...ContentSubmissionModalContextProvider_ContentSubmissionFragment\n}\n\nfragment ClozeTextElement_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        kind\n        ... on InputAndIsCorrectElementState {\n          isCorrect\n          inputElementState {\n            __typename\n            ... on ClozeTextInputElementState {\n              checkedAnswers\n            }\n          }\n        }\n        ... on ClozeTextShowAnswerElementState {\n          correctAnswers\n          lastCheckedAnswers\n        }\n        ... on ClozeTextInputElementState {\n          checkedAnswers\n        }\n        element {\n          __typename\n          ... on ClozeTextLearnElement {\n            id\n            title\n            parts {\n              __typename\n              kind\n              id\n              ... on TextPart {\n                text\n              }\n            }\n            shuffledAnswers {\n              text\n              id\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ContentSubmissionFailureModal_ContentSubmissionFragment on ContentSubmission {\n  ...ShowAnswerButton_ContentSubmissionFragment\n}\n\nfragment ContentSubmissionModalContextProvider_ContentSubmissionFragment on ContentSubmission {\n  ...ContentSubmissionFailureModal_ContentSubmissionFragment\n  ...ContentSubmissionSuccessModal_ContentSubmissionFragment\n}\n\nfragment ContentSubmissionScreen_ContentSubmissionFragment on ContentSubmission {\n  ...ELearningContentSubmissionScreen_ContentSubmissionFragment\n  ...AsyncContentSubmissionScreen_ContentSubmissionFragment\n}\n\nfragment ContentSubmissionSuccessModal_ContentSubmissionFragment on ContentSubmission {\n  ...GoToNextElementButton_ContentSubmissionFragment\n}\n\nfragment DynamicImageDisplayComponent_PodcastWithTimestampElementFragment on PodcastWithTimestampLearnElement {\n  timestampsWithImage {\n    start\n    end\n    imageFile {\n      url\n      id\n    }\n  }\n}\n\nfragment ELearningContentSubmissionScreen_ContentSubmissionFragment on ContentSubmission {\n  id\n  learnOpportunity {\n    id\n    nextContentNodeId\n    structureDefinition {\n      __typename\n      title\n    }\n    description\n    ...contentElementsCollection_LearnOpportunityV2Fragment\n    indexPath\n    root {\n      structureDefinition {\n        __typename\n        ... on LearnOpportunityRootStructureDefinition {\n          viewerTreeState {\n            __typename\n            kind\n          }\n        }\n      }\n      id\n    }\n  }\n  definition {\n    __typename\n    status\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          id\n          elementType\n          ...PodcastWithTimestamp_PodcastWithTimestampElementFragment\n        }\n      }\n      ...TextElement_ElearningContentSubmissionDefinitionFragment\n      ...VideoElement_ContentSubmissionDefinitionFragment\n      ...ImageElement_ElearningContentSubmissionDefinitionFragment\n    }\n  }\n  ...MultipleChoiceElement_ContentSubmissionFragment\n  ...OrderElement_ContentSubmissionFragment\n  ...MarkMistakesElement_ContentSubmissionFragment\n  ...MatrixElement_ContentSubmissionFragment\n  ...contentSubmissionNavigation_ContentSubmissionFragment\n  ...ContentSubmissionModalContextProvider_ContentSubmissionFragment\n  ...ClozeTextElement_ContentSubmissionFragment\n  ...contentFinished_ContentSubmissionFragment\n}\n\nfragment GoToNextElementButton_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          id\n        }\n      }\n      canGoToNext\n    }\n  }\n}\n\nfragment GoToPreviousElementButton_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          id\n          elementType\n        }\n      }\n      canGoToPrevious\n    }\n  }\n}\n\nfragment ImageElement_ElearningContentSubmissionDefinitionFragment on ActiveELearningContentSubmissionDefinition {\n  currentElementState {\n    __typename\n    element {\n      __typename\n      title\n      id\n      ... on FileLearnElement {\n        title\n        file {\n          url\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment MarkMistakesElement_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        ... on InputAndIsCorrectElementState {\n          isCorrect\n          inputElementState {\n            __typename\n            ... on MarkMistakesInputElementState {\n              checkedMistakeIndices\n            }\n          }\n        }\n        ... on MarkMistakesShowAnswerElementState {\n          correctMistakeIndices\n          lastCheckedMistakeIndices\n        }\n        ... on MarkMistakesInputElementState {\n          checkedMistakeIndices\n        }\n        kind\n        element {\n          __typename\n          elementType\n          id\n          title\n          ... on MarkMistakesLearnElement {\n            snippets {\n              content\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment MatrixElementAnswers_ELearningContentSubmissionDefinitionFragment on ActiveELearningContentSubmissionDefinition {\n  currentElementState {\n    __typename\n    element {\n      __typename\n      id\n      ... on MatrixLearnElement {\n        id\n        cells {\n          __typename\n          xIdx\n          yIdx\n          ... on AnswerMatrixLearnElementCell {\n            answers {\n              content\n            }\n            kind\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment MatrixElement_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        kind\n        ... on MatrixShowAnswerElementState {\n          kind\n          lastCheckedIndices {\n            xIdx\n            yIdx\n            index\n          }\n          correctIndices {\n            xIdx\n            yIdx\n            index\n          }\n        }\n        ... on InputAndIsCorrectElementState {\n          isCorrect\n          inputElementState {\n            __typename\n            ... on MatrixInputElementState {\n              checkedIndices {\n                xIdx\n                yIdx\n                index\n              }\n            }\n          }\n        }\n        ... on MatrixInputElementState {\n          checkedIndices {\n            index\n            xIdx\n            yIdx\n          }\n        }\n        element {\n          __typename\n          title\n          id\n          ... on MatrixLearnElement {\n            id\n            title\n            cells {\n              __typename\n              xIdx\n              yIdx\n              ... on DisplayMatrixLearnElementCell {\n                content\n                kind\n              }\n              ... on AnswerMatrixLearnElementCell {\n                answers {\n                  content\n                }\n                kind\n              }\n            }\n          }\n        }\n      }\n    }\n    ...MatrixElementAnswers_ELearningContentSubmissionDefinitionFragment\n  }\n}\n\nfragment MultipleChoiceElement_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        kind\n        ... on InputAndIsCorrectElementState {\n          isCorrect\n          inputElementState {\n            __typename\n            ... on MultipleChoiceInputElementState {\n              checkedAnswerIndices\n            }\n          }\n        }\n        ... on MultipleChoiceShowAnswerElementState {\n          correctAnswerIndices\n          lastCheckedAnswerIndices\n        }\n        ... on MultipleChoiceInputElementState {\n          checkedAnswerIndices\n        }\n        element {\n          __typename\n          title\n          id\n          ... on MultipleChoiceLearnElement {\n            question\n            answeringType\n            answeringTypeText\n            answerOptions {\n              answer\n              image {\n                url\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment OrderElement_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        kind\n        ... on InputAndIsCorrectElementState {\n          isCorrect\n          inputElementState {\n            __typename\n            ... on OrderInputElementState {\n              selectedOrder\n            }\n          }\n        }\n        ... on OrderShowAnswerElementState {\n          correctOrder\n          lastSelectedOrder\n        }\n        element {\n          __typename\n          title\n          id\n          ... on OrderLearnElement {\n            id\n            title\n            answeringTypeText\n            orderItems {\n              id\n              text\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment PodcastWithTimestamp_PodcastWithTimestampElementFragment on PodcastWithTimestampLearnElement {\n  title\n  start\n  end\n  duration\n  podcastFile {\n    url\n    id\n  }\n  ...DynamicImageDisplayComponent_PodcastWithTimestampElementFragment\n}\n\nfragment ShowAnswerButton_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment TextElement_ElearningContentSubmissionDefinitionFragment on ActiveELearningContentSubmissionDefinition {\n  currentElementState {\n    __typename\n    element {\n      __typename\n      title\n      id\n      ... on EnhancedTextLearnElement {\n        text\n        readMore\n        readMoreButtonText\n      }\n    }\n  }\n}\n\nfragment UploadElement_ContentSubmissionFragment on ContentSubmission {\n  id\n  learnOpportunity {\n    structureDefinition {\n      __typename\n      title\n    }\n    description\n    indexPath\n    id\n  }\n  definition {\n    __typename\n    ... on PassedAsyncContentSubmissionDefinition {\n      status\n      element {\n        __typename\n        ... on UploadAsyncLearnElement {\n          file {\n            id\n            name\n            url\n          }\n        }\n        id\n      }\n    }\n    ... on ActiveAsyncContentSubmissionDefinition {\n      status\n      element {\n        __typename\n        ... on UploadAsyncLearnElement {\n          file {\n            id\n            name\n            url\n          }\n        }\n        id\n        taskDescription\n      }\n    }\n  }\n}\n\nfragment VideoElement_ContentSubmissionDefinitionFragment on ActiveELearningContentSubmissionDefinition {\n  currentElementState {\n    __typename\n    element {\n      __typename\n      title\n      id\n      ... on VideoLearnElement {\n        streamFile {\n          url\n          id\n        }\n        subtitles {\n          language\n          subtitles {\n            startTimeInSec\n            endTimeInSec\n            text\n          }\n        }\n        thumbnailFile {\n          url\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment contentElementsCollection_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          elementsSummary {\n            numFileElements\n            sumTextLengthInSec\n            sumVideoLengthInSec\n            sumPodcastWithTimestampLengthInSec\n            numExerciseElements\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment contentFinished_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ELearningContentSubmissionDefinition {\n      __isELearningContentSubmissionDefinition: __typename\n      status\n    }\n    ... on PassedELearningContentSubmissionDefinition {\n      rewardResults {\n        __typename\n        ... on GamificationPoints_PointsReceivedRewardResult {\n          kind\n          points {\n            num\n            id\n          }\n        }\n      }\n    }\n    ... on FailedELearningContentSubmissionDefinition {\n      rewardResults {\n        __typename\n        ... on GamificationPoints_PointsReceivedRewardResult {\n          kind\n          points {\n            num\n            id\n          }\n        }\n      }\n    }\n  }\n  learnOpportunity {\n    id\n    root {\n      id\n      structureDefinition {\n        __typename\n        ... on LearnOpportunityRootStructureDefinition {\n          viewerTreeState {\n            __typename\n            kind\n          }\n        }\n      }\n    }\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityContentTypeDefinition {\n        __isLearnOpportunityContentTypeDefinition: __typename\n        contentNodeAdvancementResult {\n          __typename\n          status\n        }\n      }\n    }\n    nextContentNodeId\n  }\n}\n\nfragment contentSubmissionNavigation_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ELearningContentSubmissionDefinition {\n      __isELearningContentSubmissionDefinition: __typename\n      progress {\n        __typename\n        percentage\n      }\n      status\n    }\n  }\n  learnOpportunity {\n    id\n    root {\n      id\n      structureDefinition {\n        __typename\n        ... on LearnOpportunityRootStructureDefinition {\n          viewerTreeState {\n            __typename\n            kind\n          }\n          extension {\n            __typename\n            ... on PublishedRootExtensionImpl {\n              cartClickout {\n                relativeLink\n              }\n              unlockInfo {\n                __typename\n                kind\n              }\n              ihkState\n              extension {\n                __typename\n                ... on PublishedConstellationRootExtensionExtension {\n                  licenseAvailability {\n                    __typename\n                    ... on LicenseAvailabilityFreeLicensesAvailable {\n                      numAvailable\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityContentTypeDefinition {\n        __isLearnOpportunityContentTypeDefinition: __typename\n        contentNodeAdvancementResult {\n          __typename\n          status\n        }\n      }\n    }\n    nextContentNodeId\n    nextContentNode {\n      typeDefinition {\n        __typename\n        ... on LearnOpportunityELearningContentTypeDefinition {\n          extension {\n            __typename\n            ... on LearnContentExtensionImpl {\n              isUnlockNecessaryToStart\n            }\n          }\n        }\n        ... on LearnAsyncContentTypeDefinition {\n          extension {\n            __typename\n            ... on LearnContentExtensionImpl {\n              isUnlockNecessaryToStart\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n  ...GoToPreviousElementButton_ContentSubmissionFragment\n  ...GoToNextElementButton_ContentSubmissionFragment\n}\n"
  }
};
})();

(node as any).hash = "ea0d87d08e4b6f6b712d11266fed7573";

export default node;
